module.exports = __webpack_public_path__ + "img/ring_y_e_1_null@3x.36184f3a.png";